export const CRM_ACTIVITY_TYPES = ['call', 'email', 'text', 'meeting', 'note', 'stage_change'];

const COMMUNICATION_CHANNELS = new Set(['sms', 'mms', 'whatsapp', 'email']);

function latestTimestamp(...values) {
    const timestamps = values
        .filter(Boolean)
        .map((value) => new Date(value).getTime())
        .filter(Number.isFinite);
    return timestamps.length ? new Date(Math.max(...timestamps)).toISOString() : null;
}

export function buildCrmActivityTimelineEntries({
    activities = [],
    communications = [],
    staffNames = {},
    communicationAuthor = 'Communications',
} = {}) {
    const activityEntries = activities.map((activity) => ({
        id: `activity-${activity.id}`,
        kind: 'activity',
        activityType: activity.activity_type,
        recordType: activity.record_type,
        occurredAt: activity.occurred_at || activity.created_at,
        author: activity.created_by
            ? staffNames[activity.created_by] || `${activity.created_by.slice(0, 8)}…`
            : 'System',
        body: activity.body,
    }));
    const communicationEntries = communications
        .filter((thread) => COMMUNICATION_CHANNELS.has(thread.channel))
        .map((thread) => ({
            id: `communication-${thread.id}`,
            kind: 'communication',
            activityType: 'communication',
            recordType: 'account',
            occurredAt: latestTimestamp(
                thread.last_inbound_at,
                thread.last_outbound_at,
                thread.updated_at,
                thread.created_at
            ),
            author: communicationAuthor,
            body: thread.channel === 'email'
                ? `Email thread${thread.email_subject ? ` · ${thread.email_subject}` : ''}`
                : `${thread.channel.toUpperCase()} thread`,
            href: `/communications?session=${encodeURIComponent(thread.id)}`,
        }));

    return [...activityEntries, ...communicationEntries]
        .sort((left, right) => new Date(right.occurredAt || 0) - new Date(left.occurredAt || 0));
}

export function filterCrmActivityTimelineEntries(entries, filter) {
    if (filter === 'all') return entries;
    if (filter === 'communication') return entries.filter((entry) => entry.kind === 'communication');
    return entries.filter((entry) => entry.activityType === filter);
}
